module.exports = __webpack_public_path__ + "img/car.07ab3a21.svg";